import { ReactNode } from 'react';

import WidgetContact from './widgetContact';
import ExpandedWidgetContact from './widgetContact/ExpandedWidgetContact';
import WidgetExternalApplications, { WidgetExternalApplicationsConfiguration } from './widgetExternalApplications';
import ExpandedWidgetExternalApplications from './widgetExternalApplications/ExpandedWidgetExternalApplications';
import ExpandedWidgetHtml from './widgetHTML/ExpandedWidgetHtml';
import WidgetHtml, { WidgetHtmlConfiguration } from './widgetHTML/WidgetHtml';
import WidgetSimulatorsConfiguration from './widgetSimulator/configuration/WidgetSimulatorsConfiguration';
import ExpandedWidgetSimulators from './widgetSimulator/ExpandedWidgetSimulators';
import WidgetSimulators from './widgetSimulator/WidgetSimulators';
import modules from '../../modules/modules';
import { ModuleCodeEnum, WidgetTemplateType } from '../../types/widget';
import { WidgetEnum } from '../../utils/widgets';

const generalWidgets: WidgetTemplateType[] = [
	{
		component: WidgetExternalApplications,
		expandedComponent: ExpandedWidgetExternalApplications,
		configurationComponent: WidgetExternalApplicationsConfiguration,
		name: 'Applications externes',
		type: WidgetEnum.EXTERNAL_APPLICATIONS,
		minW: 1,
		maxW: Infinity,
		minH: 1,
		maxH: 1,
		moduleCode: ModuleCodeEnum.GENERAL,
		isAvailableOnDesktopFormat: true,
		isAvailableOnMobileFormat: true,
	},
	{
		component: WidgetSimulators,
		expandedComponent: ExpandedWidgetSimulators,
		configurationComponent: WidgetSimulatorsConfiguration,
		name: 'Simulateurs',
		type: WidgetEnum.SIMULATORS,
		minW: 1,
		maxW: Infinity,
		minH: 1,
		maxH: 1,
		moduleCode: ModuleCodeEnum.GENERAL,
		isAvailableOnDesktopFormat: true,
		isAvailableOnMobileFormat: true,
	},
	{
		component: WidgetHtml,
		expandedComponent: ExpandedWidgetHtml,
		configurationComponent: WidgetHtmlConfiguration,
		name: 'HTML',
		type: WidgetEnum.HTML,
		minW: 1,
		maxW: Infinity,
		minH: 1,
		maxH: Infinity,
		moduleCode: ModuleCodeEnum.GENERAL,
		isAvailableOnDesktopFormat: true,
		isAvailableOnMobileFormat: true,
	},
	{
		component: WidgetContact,
		expandedComponent: ExpandedWidgetContact,
		name: 'Contact',
		type: WidgetEnum.CONTACT,
		minW: 1,
		maxW: 1,
		minH: 2,
		maxH: 2,
		moduleCode: ModuleCodeEnum.GENERAL,
		isAvailableOnDesktopFormat: true,
		isAvailableOnMobileFormat: true,
	},
];

export const widgetsByModule: {
	module: { code: string; name: string; icon: ReactNode };
	widgets: WidgetTemplateType[];
}[] = [
	{
		module: { code: 'general', name: 'Général', icon: null },
		widgets: generalWidgets,
	},
	...modules.flatMap(({ code, name, icon, widgets: moduleWidgets }) =>
		moduleWidgets
			? [
					{
						module: { code, name, icon },
						widgets: moduleWidgets.sort((a, b) => a.name.localeCompare(b.name)),
					},
			  ]
			: [],
	),
];

export const getWidgetTemplateByType = (type: WidgetEnum): WidgetTemplateType => {
	const widgetTemplates = [...generalWidgets, ...modules.flatMap(({ widgets }) => widgets ?? [])];
	const widgetTemplate = widgetTemplates.find((template) => template.type === type);

	if (!widgetTemplate) {
		throw new Error(`Unsupported widget type ${type}`);
	}

	return widgetTemplate;
};
